<template>
    <div class="loader-inline">
        <div class="loader-img-inline" :id="componentId">
            <div></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InlineLoader',
    computed: {
        componentId() {
            return `InlineLoader${Math.floor((Math.random() * 1000) + 1)}`;
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    //start -- Temp for ball-scale-ripple-multiple
    $overlayLoaderTextColor: $dark-300;
    $overlayLoaderImgColor: $light-800;
    $overlayLoaderImgSize: 50px;
    $overlayLoaderMediumImgSize: 30px;
    //end

    //inline (actions, in buttons....)
    $inlineLoaderImgSize: 13px;
    $inlineLoaderTextColor: $dark-300;
    $inlineLoaderImgColor: $light-800;

    //inline loader Wrapper
    .loader-inline {
        display: inline-flex;
        vertical-align: middle;
        height: $inlineLoaderImgSize;

        .loader-txt {
            @include font(5);
            padding-left: 4px;
            padding-top: 1px;
            color: $inlineLoaderTextColor;
        }
    }

    //overlay loader style
    @import "ball-scale-ripple-multiple";
</style>
